module.exports = __webpack_public_path__ + "img/empty.39e0a2b4.png";